import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccentButtonStyleType, ButtonType } from './button-types.enum';

@Component({
  selector: 'cwo-accent-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './accent-button.component.html',
  styleUrl: './accent-button.component.scss',
})
export class AccentButtonComponent {
  buttonType = input<ButtonType>(ButtonType.BUTTON);
  ariaLabel = input<string>();
  fullWidth = input<boolean>(false);
  bold = input<boolean>(false);
  fontSize = input<'small' | 'normal' | 'large'>('normal');
  height = input<'xsmall' | 'small' | 'medium' | 'mediumLarge' | 'large' | 'xlarge'>('large');

  accentButtonStyle = input<AccentButtonStyleType>(
    AccentButtonStyleType.DEFAULT
  );
  accentButtonStyleType = AccentButtonStyleType;
}
